module.exports = __webpack_public_path__ + "img/applicationConstruction-sjfx.18b7e7d2.png";